import * as customerActions from '../actions/customerActions';
import * as navigationActions from '../actions/navigationActions';
const initialState = {};
export default (state = initialState, action) => {
  //NOSONAR
  switch (
    action.type //NOSONAR
  ) {
    case customerActions.CUSTOMER_SEGMENT_DATA: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case navigationActions.NEXT_SEGMENT: {
      return {
        ...state,
        formValues: {
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
};
